import Header from "components/Header";
import { routes } from "constants/routes";
import { usePullToRefresh } from "context/PullToRefreshContext";
import useAppStateChange from "hooks/useAppStateChange";
import useDeviceType from "hooks/useDeviceType";
import MainLayout from "layouts/Main";
import FRListByStatusDesktop from "../../modules/FRListByStatusDesktop";
import SearchInput from "../../modules/FRListByStatusDesktop/components/SearchInput";
import { useManagePaySummary } from "../../modules/useManagePaySummary";
import StatusSummary from "../../Shared/StatusSummary";
import styles from "./style.module.scss";

export default function CarrierManagePay() {
  const { isDesktop } = useDeviceType();
  const { state, summaryData, refetch, handleSearch } = useManagePaySummary();
  useAppStateChange((isActive) => isActive && refetch());
  usePullToRefresh(refetch);

  return (
    <MainLayout
      desktopTitle="Manage Pay"
      customHeader={<Header label="Manage Pay" goBackPath={routes.HAULPAY} isHideDesktop />}
      className={styles.managePayContainer}>
      {summaryData &&
        (!isDesktop ? (
          <>
            <SearchInput
              initialValue={""}
              onSearch={handleSearch}
              isMobile={true}
              iconClassName="absolute inset-y-0 my-auto text-placeholder left-4"
            />
            <StatusSummary
              summaryData={summaryData}
              debtor={state?.debtor}
              debtorName={state?.debtorName}
            />
          </>
        ) : (
          <FRListByStatusDesktop
            summaryData={summaryData}
            debtor={state?.debtor}
            refetchSummaryData={refetch}
            debtorName={state?.debtorName}
          />
        ))}
    </MainLayout>
  );
}
